module.exports = __webpack_public_path__ + "static/media/akt-affiliate.b8ab72d5.png";